import { POST } from '@/api'

/**
 * ぐるなびネット予約クーポン利用可否判定
 */
export default {
  namespaced: true,
  state: {
    isValid: false,
    busy: false,
  },
  mutations: {
    set(state, val) {
      state.isValid = val
    },
    busy(state, busy) {
      state.busy = busy
    },
  },
  getters: {},
  actions: {
    async checkValid(store, { storeId, rsvId, persons, calendarDate, startTime, courseId }) {
      const { commit, dispatch, rootGetters } = store
      commit('busy', true)
      // API叩く前にコース一覧取得
      await dispatch('courses/get', null, { root: true })

      const { status, message, data } = await POST('/api/web/v2/gnavi/couponvalidity', {
        storeId,
        rsvId,
        persons,
        calendarDate,
        startTime,
        coursePrice: courseId ? rootGetters['courses/all'].find(obj => obj.id === courseId).price : 0,
      })

      if (status === 200) {
        commit('set', data.isValid)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
